import { App, DirectiveBinding } from "vue";
import { useAuthStore } from "@/store/authStore";
import { useNotificationStore } from "@/store/notificationStore";

export function setupAuthDirectives(app: App) {
  // v-can-scope directive
  app.directive("can-scope", {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
      const authStore = useAuthStore();
      const requiredScope = binding.value;

      if (!authStore.hasScope(requiredScope)) {
        el.classList.add("disabled");
        el.setAttribute("disabled", "true");
        // Optionally add a none-display class instead of disabled
        // el.style.display = "none";
      }
    },
  });

  // v-can-perform directive
  app.directive("can-perform", {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
      const authStore = useAuthStore();
      const { operation } = binding.value;

      if (!authStore.canPerform(operation)) {
        el.classList.add("disabled");
        el.setAttribute("disabled", "true");
        // Optionally add a none-display class instead of disabled
        // el.style.display = "none";
      }
    },
  });

  // v-auth-click directive - shows warning when clicked if not authorized
  app.directive("auth-click", {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
      const authStore = useAuthStore();
      const notificationStore = useNotificationStore();
      const { roles, message } = binding.value;

      let authorized = true;
      if (typeof roles === "boolean") {
        authorized = roles;
      }
      // Original format: Check if roles is an array of strings
      else if (Array.isArray(roles)) {
        authorized = roles.some((role) => authStore.hasRole(role));
      }

      if (!authorized) {
        // Remove all existing click handlers
        const clone = el.cloneNode(true) as HTMLElement;
        if (el.parentNode) {
          el.parentNode.replaceChild(clone, el);
        }

        // Add our authorized click handler
        clone.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          const warningMessage =
            message || "Sie haben keine Berechtigung für diese Aktion.";
          notificationStore.showWarning(warningMessage);
        });

        // Visual indication that the element is disabled
        clone.classList.add("auth-disabled");
        clone.style.opacity = "0.6";
        clone.style.cursor = "not-allowed";
      }
    },
  });
}
